import {
    AutocompleteInput,
    DateInput,
    Edit,
    ReferenceInput,
    SimpleForm,
    TextInput
} from '@/components/admin';
import { PackageCheck } from 'lucide-react';
import { useRecordContext } from 'ra-core';
import { AutoReferenceField } from '../documents/shared/AutoReferenceField';
import { StatusSelectInput } from '../documents/shared/StatusSelectInput';

const GRNEditForm = () => {
    const record = useRecordContext<any>();

    return (
        <SimpleForm className="max-w-4xl">
            <div className="mb-6 flex items-center gap-3 text-foreground pb-4 border-b">
                <div className="w-10 h-10 bg-emerald-50 rounded-lg flex items-center justify-center border border-emerald-100">
                    <PackageCheck className="w-5 h-5 text-emerald-600" />
                </div>
                <div>
                    <h3 className="text-lg font-bold">Edit Goods Receipt Note (GRN)</h3>
                    <p className="text-xs text-muted-foreground">Update receipt details</p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mb-4">
                <AutoReferenceField docType="goods_receipt" existingValue={record?.reference} />
                <DateInput source="received_date" label="Received Date" required />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mb-4">
                <ReferenceInput source="po_id" reference="purchase_orders" perPage={100} sort={{ field: 'date', order: 'DESC' }}>
                    <AutocompleteInput label="Purchase Order" optionText="reference" isRequired />
                </ReferenceInput>

                <ReferenceInput source="vendor_id" reference="vendors" perPage={100}>
                    <AutocompleteInput label="Vendor" optionText="name" isRequired />
                </ReferenceInput>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mb-4">
                <StatusSelectInput
                    source="status"
                    isRequired
                    choices={[
                        { id: 'draft',     name: 'Draft — pending verification' },
                        { id: 'received',  name: 'Received — goods on hand' },
                        { id: 'qa_passed', name: 'QA Passed — ready for billing' },
                        { id: 'qa_failed', name: 'QA Failed — return/rework needed' },
                    ]}
                />
                <TextInput source="notes" label="Notes / Remarks" multiline rows={3} />
            </div>
        </SimpleForm>
    );
};

export const GRNEdit = () => (
    <Edit title="Edit Goods Receipt" redirect="show">
        <GRNEditForm />
    </Edit>
);
